export default "__VITE_ASSET__Cdot60q3__"